import type {FC, PropsWithChildren} from 'react';
import {cn} from '../../../../../lib/classname';

type Props = {
  className?: string;
};
export const Carousel: FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  return (
    <div className={cn('relative')}>
      <div
        className={cn('flex overflow-x-auto items-stretch', className)}
        style={{
          overscrollBehaviorX: 'contain',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {children}
      </div>
    </div>
  );
};
